module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/kubernetes.c422f4f3.svg";